import React, { useState, useEffect } from "react";
import {
    Formulario,
    ContenedorTerminos,
    ContenedorBotonCentrado,
    LeyendaError
} from "../componentes/GeneralComponents/Formularios";

import InputAntd from "../componentes/GeneralComponents/InputAntd";
import SelectAntd from "../componentes/GeneralComponents/SelectAntd";
import { register_request, emailValidation_request, activationAccount_request } from "../services/register_services";
import { getEstado_request, getLocalidad_request } from "../services/expediente_service";

// navegacion de verificacion
import { Link, useLocation, useNavigate } from "react-router-dom";

//importando libreria Hormiga
import { Button, Checkbox, Col, ConfigProvider, Input, Row, Select } from "antd";

// logo Ygia
import logo from "../logo.svg";

// Imagen Medico
import ImagenMedico from "../Img/escritorio-doctor.png"

// Logo blancoYgia
import LogoBlanco from "../Img/logoblancoygia.svg"

// impotando iconos
import icono from "../componentes/IconosDeSitio";
import Modal from "../componentes/GeneralComponents/ModalDetalle";

import { UseModal } from "../hooks/UseModal";
import { login_request } from "../services/login_services";
import TerminosModal from "../componentes/Registro/Terminos";

import "dayjs/locale/es";

import {
    Stack,
    Snackbar,
    Alert as MuiAlert,
} from '@mui/material';

import { Loader } from "../componentes/GeneralComponents/Loader";
import InputFileSingle from "../componentes/GeneralComponents/InputFileSingle";
import LoaderModals from "../componentes/GeneralComponents/Loader_modals";
import ButtonAntd from "../componentes/GeneralComponents/ButtonAntd";
import Campos from "../componentes/GeneralComponents/campos";
import ReactGA from "react-ga4";
import { useDispatch } from 'react-redux';
import { showSnackbar } from "../redux/snackbarSlice";
import InputDate from "../componentes/GeneralComponents/InputDate";
import profesiones from "../utils/especialidades";
import { getTokenFirebase } from "../firebase";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const RegistroNuevo = () => {
    const location = useLocation();

    // ******* VARIABLES *******

    const expresiones = {
        textos: /^[a-zA-ZÀ-ÿ\s]{1,}$/, // Letras y espacios, pueden llevar acentos.
        // password: /^.{8,}$/, // 4 a 12 digitos.
        password: /^[a-zA-Z0-9]{8,}$/, // Letras y numeros.
        correo: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        telefono: /^\d{1,}$/, // 7 a 14 numeros.
        codigo: /^\d{1,4}$/, // 7 a 14 numeros.
        textNumber: /^[a-zA-Z0-9À-ÿ\s]{4,}$/, // Letras, Numeros y espacios, pueden llevar acentos.
        cedula: /^[0-9a-zA-Z]{1,}$/,
        direccion: /^[-./#a-zA-Z0-9À-ÿ\s]{10,}$/, // Letras, Numeros y espacios, pueden llevar acentos.
        // nacimiento: getEdad, // Letras y espacios, pueden llevar acentos.
    };

    const dispatch = useDispatch();
    //navegacion
    const navigate = useNavigate();

    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];

    // ******* USE STATES *******

    // Metodos de modalales
    const [CloseModalR] = UseModal(false);
    const [isopenModal2r, openModal2r, closeModal2r] = UseModal(false)
    const [isopenModalCodigo, openModalCodigo, closeModalCodigo] = UseModal(false)

    // Desplegar inputs y divs
    const [Desplegar, setDesplegar] = useState(0);

    const [EstadosList, setEstadosList] = useState([]);
    const [LocalidadesList, setLocalidadesList] = useState([]);

    // Sacar nombre de imagen de file
    const [CedulaFile, setCedulaFile] = useState({ name: "", url: "", file: "", size: 0, formato: "" });
    const [ProfileImage, setProfileImage] = useState("");
    const [Typefile, setTypefile] = useState(0);
    const [Edad, setEdad] = useState(false);

    // Declarando estado de inputs
    const [Nombre, setNombre] = useState("");
    const [Password, setPassword] = useState("");
    const [Password2, setPassword2] = useState("");
    const [Correo, setCorreo] = useState("");
    const [Telefono, setTelefono] = useState(null);
    const [TelEmergencia, setTelEmergencia] = useState(null);
    const [Terminos, setTerminos] = useState(false);
    const [FormularioValido, setFormularioValido] = useState(null);
    const [Direccion, setDireccion] = useState("");
    const [ApePaterno, setApePaterno] = useState("");
    const [ApeMaterno, setApeMaterno] = useState("");
    const [NombreComercial, setNombreComercial] = useState("");
    const [Subespecialidad, setSubespecialidad] = useState("");
    const [Cedula, setCedula] = useState("");
    const [Universidad, setUniversidad] = useState("");
    const [Nacimiento, setNacimiento] = useState(null);
    const [Sexo, setSexo] = useState(null);
    const [UserRoll, setUserRoll] = useState(null);
    const [CanalOrigen, setCanalOrigen] = useState('');
    const [Prefijo, setPrefijo] = useState(null);
    const [Profesion, setProfesion] = useState(null);
    const [Estado, setEstado] = useState(null);
    const [Localidad, setLocalidad] = useState(null);


    const [MensajeNombre, setMensajeNombre] = useState("true");
    const [MensajeApePaterno, setMensajeApePaterno] = useState("true");
    const [MensajeApeMaterno, setMensajeApeMaterno] = useState("true");
    const [MensajePassword, setMensajePassword] = useState("true");
    const [TextoMensajePassword, setTextoMensajePassword] = useState("true");

    const [MensajePassword2, setMensajePassword2] = useState("true");
    const [TextoMensajePassword2, setTextoMensajePassword2] = useState("true");
    const [MensajeCorreo, setMensajeCorreo] = useState("true");
    const [MensajeTelefono, setMensajeTelefono] = useState("true");
    const [MensajeTelEmergencia, setMensajeTelEmergencia] = useState("true");
    const [MensajeNacimiento, setMensajeNacimiento] = useState("true");
    const [MensajeCedula, setMensajeCedula] = useState("true");
    const [MensajeUniversidad, setMensajeUniversidad] = useState("true");
    const [MensajeProfesion, setMensajeProfesion] = useState("true");
    const [MensajeNombreComercial, setMensajeNombreComercial] = useState("true");
    const [MensajeDireccion, setMensajeDireccion] = useState("true");
    const [MensajeSubespecialidad, setMensajeSubespecialidad] = useState("true");
    const [MensajeCodigo, setMensajeCodigo] = useState("true");
    const [MensajeEstado, setMensajeEstado] = useState("true");
    const [MensajeLocalidad, setMensajeLocalidad] = useState("true");

    // imagen de
    const [image, setimage] = useState("");

    // Validacion de codigo de modal
    const [Codigo, setCodigo] = useState("");

    const [loader, setLoader] = useState(false);
    const [loaderModal, setLoaderModal] = useState(false);

    const [openCode, setOpenCode] = useState(false);

    // MANEJA DE MENSAJES
    const [open, setOpen] = useState(false);
    const [typeMessage, setTypeMessage] = useState("");
    const [message, setMessage] = useState("");

    const [comboRol, setComboRol] = useState(null);
    const [comboCanalOrigen, setComboCanalOrigen] = useState(null);
    const [comboGenero, setComboGenero] = useState(null);
    const [comboPrefijo, setComboPrefijo] = useState(null);
    const [checkTerminos, setCheckTerminos] = useState(null);
    const [archivoExist, setArchivoExist] = useState(null);

    // ******* FUNCIONES *******
    const validacion = async () => {
        setLoaderModal(true);
        if (!!Codigo && MensajeCodigo !== "false") {
            let firebasetoken = localStorage.getItem("firebaseToken");
            let requestData = {
                "Codigo": Codigo,
            };
            let response = await activationAccount_request(requestData);
            if (response["ok"]) {
                ReactGA.event({
                    category: "Registro",
                    action: "Codigo_exitoso",
                    label: "Código de verificación correcto", // optional
                    value: 99, // optional, must be a number
                    nonInteraction: true, // optional, true/false
                    transport: "xhr", // optional, beacon/xhr/image
                });

                if (document.domain !== "ygia.app") {
                    console.log(Correo);
                    console.log(UserRoll);
                }
                // return;

                let request = {
                    "Correo": Correo,
                    "password": Password,
                    "device_token": !!!firebasetoken ? "" : firebasetoken,
                    "Tipo": UserRoll
                };

                let responseLogin = await login_request(request);
                if (responseLogin["ok"]) {
                    getTokenFirebase();
                    localStorage.setItem("logged", true);
                    localStorage.setItem("statusModalQrApp", "true");
                    localStorage.setItem("statusModalRecetaCustom", "true");
                    localStorage.setItem("statusModalTutoriales", "true");
                    navigate("/app/welcome-page", {
                        replace: true,
                        state: {
                            logged: true
                        },
                    });
                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: responseLogin.mensaje,
                        type: "error",
                    }));
                    navigate('/', { replace: true });
                }

            }
            else {
                dispatch(showSnackbar({
                    show: true,
                    text: response.mensaje,
                    type: "error",
                }));
            }
        } else {
            setMensajeCodigo("false");
            dispatch(showSnackbar({
                show: true,
                text: "Escriba un código",
                type: "warning",
            }));
        }
        setLoaderModal(false);
        return;
    };

    const validarPassword2 = (texto) => {
        if (Password !== texto) {
            // console.log("No coinciden");
            setTextoMensajePassword2("Las contraseñas no coinciden");
            setMensajePassword2("false");
        } else {
            // console.log("coinciden");
            setTextoMensajePassword2("");
            setMensajePassword2("true");
        }
    };

    const onSubmit = async () => {
        // openModalCodigo(true);
        // setShowLicencias(1);
        // return;
        console.log(Estado);

        setLoader(true);
        // console.log(Telefono);
        // console.log(Correo);
        if (UserRoll === "1") {
            if (MensajeNombre === "true" && !!Nombre &&
                MensajeApePaterno === "true" && !!ApePaterno &&
                MensajePassword === "true" && !!Password &&
                MensajePassword2 === "true" && !!Password2 &&
                MensajeCorreo === "true" && !!Correo &&
                MensajeTelefono === "true" && !!Telefono &&
                Terminos &&
                MensajeNacimiento === "true" && !!Nacimiento &&
                !!Sexo &&
                !!Prefijo && !!Profesion &&
                !!Cedula && MensajeCedula !== "false" &&
                MensajeEstado === "true" && !!Estado &&
                MensajeLocalidad === "true" && !!Localidad
                // !!CedulaFile.file &&
                // MensajeUniversidad === "true" && !!Universidad
            ) {
                let email_data = {
                    "Email": Correo,
                    "Tipo": UserRoll

                };

                let mailVal = await emailValidation_request(email_data);
                if (mailVal["ok"]) {
                    let estado = "";
                    EstadosList.forEach(element => {
                        if (element.id === Estado) {
                            estado = element.Estado;
                        }
                    });

                    let arrayNacimientoTemp = Nacimiento.split("/");
                    let fechaNacimiento = `${arrayNacimientoTemp[2]}-${arrayNacimientoTemp[1]}-${arrayNacimientoTemp[0]}`

                    let registerData = new FormData();
                    registerData.append("Nombre", Nombre);
                    registerData.append("ApellidoPaterno", ApePaterno);
                    registerData.append("ApellidoMaterno", ApeMaterno);
                    registerData.append("Genero", Sexo);
                    registerData.append("Nacimiento", fechaNacimiento);
                    registerData.append("Prefijo", Prefijo);
                    registerData.append("Profesion", Profesion);
                    registerData.append("NumeroCedula", Cedula);
                    registerData.append("Universidad", Universidad);
                    registerData.append("Celular", Telefono);
                    registerData.append("Email", Correo);
                    registerData.append("Password", Password);
                    registerData.append("TelefonoEmergencia", TelEmergencia);
                    registerData.append("NombreComercial", NombreComercial);
                    registerData.append("source_channel", CanalOrigen);
                    registerData.append("Direccion", Direccion);
                    registerData.append("Estado", estado);
                    registerData.append("Localidad", Localidad);
                    // console.log(image);
                    if (!!image) {
                        registerData.append("Imagen", ProfileImage, image);
                    }

                    // registerData.append("CedulaFile", CedulaFile.file, CedulaFile.name);
                    registerData.append("Medico", "1");

                    let response = await register_request(registerData);

                    if (response["ok"]) {
                        ReactGA.event({
                            category: "Registro",
                            action: "Creacion_de_cuenta_medico_exitoso",
                            label: "Cuenta creada con exito", // optional
                            value: 99, // optional, must be a number
                            nonInteraction: true, // optional, true/false
                            transport: "xhr", // optional, beacon/xhr/image
                        });
                        dispatch(showSnackbar({
                            show: true,
                            text: "Registro exitoso",
                            type: "success",
                        }));
                        openModalCodigo(true);
                    } else {
                        ReactGA.event({
                            category: "Registro",
                            action: "Creacion_de_cuenta_medico_erroneo",
                            label: `${response.mensaje}`, // optional
                            value: 99, // optional, must be a number
                            nonInteraction: true, // optional, true/false
                            transport: "xhr", // optional, beacon/xhr/image
                        });
                        dispatch(showSnackbar({
                            show: true,
                            text: response.mensaje,
                            type: "error",
                        }));
                    }

                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: mailVal.mensaje,
                        type: "error",
                    }));

                }
            } else {

                if (!!!Sexo) {
                    setComboGenero("false");
                }

                if (!!!Nombre) {
                    setMensajeNombre("false");
                }

                if (!!!ApePaterno) {
                    setMensajeApePaterno("false");
                }

                if (!!!Password) {
                    setMensajePassword("false");
                }

                if (!!!Password2) {
                    setMensajePassword2("false");
                }

                if (!!!Correo) {
                    setMensajeCorreo("false");
                }
                if (!!!Telefono) {
                    setMensajeTelefono("false");
                }

                if (!Terminos) {
                    setCheckTerminos("false");
                }

                if (!!!Nacimiento) {
                    setMensajeNacimiento("false");
                }

                if (!!!Prefijo) {
                    setComboPrefijo("false");
                }
                if (!!!Profesion) {
                    setMensajeProfesion("false");
                }

                if (!!!Cedula) {
                    setMensajeCedula("false");
                }

                if (!!!Universidad) {
                    setMensajeUniversidad("false");
                }

                if (!!!CedulaFile.file) {
                    setArchivoExist("false");
                }

                if (!!!Estado) {
                    setMensajeEstado("false");
                }

                if (!!!Localidad) {
                    setMensajeLocalidad("false");
                }

                dispatch(showSnackbar({
                    show: true,
                    text: "Faltan campos por completar",
                    type: "warning",
                }));
            }
        } else {
            if (MensajeNombre === "true" && !!Nombre &&
                MensajeApePaterno === "true" && !!ApePaterno &&
                MensajePassword === "true" && !!Password &&
                MensajePassword2 === "true" && !!Password2 &&
                MensajeCorreo === "true" && !!Correo &&
                MensajeTelefono === "true" && !!Telefono &&
                Terminos &&
                MensajeNacimiento === "true" && !!Nacimiento &&
                MensajeEstado === "true" && !!Estado &&
                MensajeLocalidad === "true" && !!Localidad &&
                !!Sexo) {
                let email_data = {
                    "Email": Correo,
                    "Tipo": UserRoll
                };

                let mailVal = await emailValidation_request(email_data);
                if (mailVal["ok"]) {
                    let registerData = new FormData();
                    registerData.append("Nombre", Nombre);
                    registerData.append("ApellidoPaterno", ApePaterno);
                    registerData.append("ApellidoMaterno", ApeMaterno);
                    registerData.append("Genero", Sexo);
                    registerData.append("Nacimiento", Nacimiento);
                    registerData.append("Prefijo", "");
                    registerData.append("Profesion", "");
                    registerData.append("NumeroCedula", "");
                    registerData.append("Celular", Telefono);
                    registerData.append("Email", Correo);
                    registerData.append("Password", Password);
                    registerData.append("TelefonoEmergencia", TelEmergencia);
                    registerData.append("NombreComercial", "");
                    registerData.append("source_channel", CanalOrigen);
                    registerData.append("Direccion", "");
                    registerData.append("Estado", Estado);
                    registerData.append("Localidad", Localidad);
                    // console.log(image);
                    if (!!image) {
                        registerData.append("Imagen", ProfileImage, image);
                    }

                    registerData.append("Asistente", "1");

                    let response = await register_request(registerData);

                    if (response["ok"]) {
                        ReactGA.event({
                            category: "Registro",
                            action: "Creacion_de_cuenta_asistente_exitoso",
                            label: "Cuenta creada con exito", // optional
                            value: 99, // optional, must be a number
                            nonInteraction: true, // optional, true/false
                            transport: "xhr", // optional, beacon/xhr/image
                        });
                        dispatch(showSnackbar({
                            show: true,
                            text: "Registro exitoso",
                            type: "success",
                        }));
                        openModalCodigo(true);
                    } else {
                        ReactGA.event({
                            category: "Registro",
                            action: "Creacion_de_cuenta_asistente_erroneo",
                            label: `${response.mensaje}`, // optional
                            value: 99, // optional, must be a number
                            nonInteraction: true, // optional, true/false
                            transport: "xhr", // optional, beacon/xhr/image
                        });
                        dispatch(showSnackbar({
                            show: true,
                            text: response.mensaje,
                            type: "error",
                        }));
                    }

                } else {
                    dispatch(showSnackbar({
                        show: true,
                        text: mailVal.mensaje,
                        type: "error",
                    }));

                }
            } else {

                if (!!!Sexo) {
                    setComboGenero("false");
                }

                if (!!!Nombre) {
                    setMensajeNombre("false");
                }

                if (!!!ApePaterno) {
                    setMensajeApePaterno("false");
                }

                if (!!!Password) {
                    setMensajePassword("false");
                }

                if (!!!Password2) {
                    setMensajePassword2("false");
                }

                if (!!!Correo) {
                    setMensajeCorreo("false");
                }
                if (!!!Telefono) {
                    setMensajeTelefono("false");
                }

                if (!Terminos) {
                    setCheckTerminos("false");
                }

                if (!!!Nacimiento) {
                    setMensajeNacimiento("false");
                }

                if (!!!Estado) {
                    setMensajeEstado("false");
                }

                if (!!!Localidad) {
                    setMensajeLocalidad("false");
                }

                dispatch(showSnackbar({
                    show: true,
                    text: "Faltan campos por completar",
                    type: "warning",
                }));
            }

        }
        setLoader(false);
        return;
    };

    async function getEstados() {
        let response = await getEstado_request();
        if (response.ok) {
            // console.log(response.data);
            let estados_temp = []
            response.data.forEach(estado => {
                estados_temp.push({ value: estado.id.toString(), label: estado.Estado });
            });
            setEstadosList(estados_temp);
        } else {
            setEstadosList([]);
        }
    }

    async function getLocalidades(estado) {
        let response = await getLocalidad_request(estado);
        if (response.ok) {
            // console.log(response.data);
            let localidades_temp = []
            response.data.forEach(estado => {
                localidades_temp.push({ value: estado, label: estado });
            });
            setLocalidadesList(localidades_temp);
        } else {
            setLocalidadesList([]);
        }
    }

    function cleanInputsDoctor() {
        setCedulaFile({ name: "", url: "", file: "", size: 0, formato: "" });
        setCedula("");
        setSubespecialidad("");
        setDireccion("");
        setNombreComercial("");
        setCanalOrigen();
    }

    function filterOptions(input, option) {
        var chars = {
            "á": "a", "é": "e", "í": "i", "ó": "o", "ú": "u",
            "à": "a", "è": "e", "ì": "i", "ò": "o", "ù": "u", "ñ": "n",
            "Á": "A", "É": "E", "Í": "I", "Ó": "O", "Ú": "U",
            "À": "A", "È": "E", "Ì": "I", "Ò": "O", "Ù": "U", "Ñ": "N"
        }
        var expr = /[áàéèíìóòúùñ]/ig;
        return option?.label.replace(expr, function (e) { return chars[e] }).toLowerCase().indexOf(input.replace(expr, function (e) { return chars[e] }).toLowerCase()) > -1
    }

    function filterSort(optionA, optionB) {
        var chars = {
            "á": "a", "é": "e", "í": "i", "ó": "o", "ú": "u",
            "à": "a", "è": "e", "ì": "i", "ò": "o", "ù": "u", "ñ": "n",
            "Á": "A", "É": "E", "Í": "I", "Ó": "O", "Ú": "U",
            "À": "A", "È": "E", "Ì": "I", "Ò": "O", "Ù": "U", "Ñ": "N"
        }
        var expr = /[áàéèíìóòúùñ]/ig;
        return (optionA?.label.replace(expr, function (e) { return chars[e] }).toLowerCase() ?? "").replace(expr, function (e) { return chars[e] }).toLowerCase().localeCompare((optionB?.label.replace(expr, function (e) { return chars[e] }).toLowerCase() ?? "").replace(expr, function (e) { return chars[e] }).toLowerCase())
    }

    function gtag_report_conversion() {
        // Ejecutar evento de conversión
        window.gtag("event", "conversion", {
            send_to: "AW-17156846047/IhuSCJ6G0tMaEN_jgvU_",
            value: 1.0, // puedes hacerlo dinámico
            currency: "MXN",
        });
    }

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname,
            title: location.pathname,
        });
        gtag_report_conversion();
        getEstados();
    }, [])

    const styleDet = {
        height: "clac(100vh - 52px)",
        width: "clac(100vw - 52px)",
        margin: "0 2%",
    };


    return (
        <main>
            <Stack>
                {loader ? (<Loader />) : (
                    <Row justify="center">
                        <Col sm={{ flex: "50%" }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Formulario action="" onSubmit={onSubmit}>
                                    <Row justify="space-between" style={{ width: "100%" }}>
                                        <Col sm={{ flex: "50%" }}>
                                            <h1 style={{ color: "#148f9f" }}>Registro</h1>
                                            <div style={{ textAlign: "start", marginBottom: "1%", marginTop: "1%", width: "80%" }}>
                                                <label htmlFor="imagenPerfil">
                                                    <img
                                                        style={{
                                                            width: "90px",
                                                            height: "90px",
                                                            border: "2px solid #d7d7d7",
                                                            borderRadius: "3rem",
                                                            cursor: "pointer",
                                                            overflow: "hidden",
                                                            marginBottom: "4px",
                                                            objectFit: "cover",
                                                        }}
                                                        src={image !== "" ? image : icono[0]}
                                                        alt=""
                                                    />
                                                </label>
                                                <input
                                                    type="file"
                                                    id="imagenPerfil"
                                                    accept="/image/x-PNG,image/jpeg, image/png, image/*"
                                                    style={{ display: "none" }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file && file.type.substring(0, 5) === "image") {
                                                            setimage(URL.createObjectURL(e.target.files[0]));
                                                            setProfileImage(e.target.files[0]);
                                                        } else {
                                                            setOpen(true);
                                                            setTypeMessage("warning");
                                                            setMessage("Formato no valido");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col sm={{ flex: "50%" }} style={{ textAlign: "end" }}>
                                            <img src={icono[29]} alt="" className="imgRoundedMedicos" />
                                        </Col>
                                    </Row>

                                    <InputAntd
                                        label="Correo electrónico:"
                                        requiredICon={true}
                                        style={{ marginBottom: "1%", width: "100%", borderRadius: "15px" }}
                                        styleDiv={{ width: "100%" }}
                                        className="inputblue"
                                        value={Correo}
                                        type="email"
                                        setStateValue={setCorreo}
                                        placeholder="escribe tu correo"
                                        valueError={MensajeCorreo}
                                        setStateError={setMensajeCorreo}
                                        textError={["Este campo es obligatorio", "Formato correo erroneo", ""]}
                                        vacio={false}
                                        expresionRegular={expresiones.correo}
                                        maxLength={70}
                                    />

                                    <Campos
                                        label="Contraseña:"
                                        requiredICon={true}
                                        valueError={MensajePassword}
                                        textError={TextoMensajePassword}
                                        vacio={false}
                                        styleDiv={{ height: "25px", marginBottom: "45px" }}
                                        classname="widthNormalButton"
                                    >
                                        <Input.Password
                                            className="inputblue widthNormalButton"
                                            style={{ padding: "0 10px", width: "100%", borderRadius: "15px" }}
                                            placeholder="Escribe una contraseña"
                                            status={MensajePassword === "false" && "error"}
                                            onChange={(e) => {
                                                if (expresiones.password.test(e.target.value)) {
                                                    setPassword(e.target.value);
                                                    if (e.target.value.length < 8) {
                                                        setTextoMensajePassword("Min. 8 caracteres (letras y numeros)")
                                                        setMensajePassword("false");
                                                    } else {
                                                        setTextoMensajePassword("");
                                                        setMensajePassword("true");
                                                    }
                                                } else {
                                                    if (!!e.target.value) {
                                                        if (e.target.value.length < 8) {
                                                            setTextoMensajePassword("Min. 8 caracteres (letras y numeros)");
                                                            setMensajePassword("false");
                                                        } else {
                                                            setTextoMensajePassword("Solo se permiten letras y numeros");
                                                            setMensajePassword("false");
                                                        }
                                                    } else {
                                                        setTextoMensajePassword("Este campo es obligatorio");
                                                        setMensajePassword("false");
                                                    }
                                                }
                                            }}
                                            maxLength={16}
                                        />
                                    </Campos>

                                    <Campos
                                        label="Repetir contraseña:"
                                        requiredICon={true}
                                        valueError={MensajePassword2}
                                        textError={TextoMensajePassword2}
                                        vacio={false}
                                        styleDiv={{ height: "40px", marginBottom: "40px", width: "100%" }}
                                    >
                                        <Input.Password
                                            className="inputblue"
                                            style={{ padding: "0 10px", width: "100%", borderRadius: "15px" }}
                                            placeholder="Repita su contraseña"
                                            status={MensajePassword2 === "false" && "error"}
                                            onChange={(e) => {
                                                if (expresiones.password.test(e.target.value)) {
                                                    setPassword2(e.target.value);
                                                    if (e.target.value.length < 8) {
                                                        setTextoMensajePassword2("Min. 8 caracteres (letras y numeros)")
                                                        setMensajePassword2("false");
                                                    } else {
                                                        validarPassword2(e.target.value);
                                                        // setTextoMensajePassword2("");
                                                        // setMensajePassword2("true");
                                                    }
                                                } else {
                                                    if (!!e.target.value) {
                                                        if (e.target.value.length < 8) {
                                                            setTextoMensajePassword2("Min. 8 caracteres (letras y numeros)");
                                                            setMensajePassword2("false");
                                                        } else {
                                                            setTextoMensajePassword2("Solo se permiten letras y numeros");
                                                            setMensajePassword2("false");
                                                        }
                                                    } else {
                                                        setTextoMensajePassword2("Este campo es obligatorio");
                                                        setMensajePassword2("false");
                                                    }
                                                }
                                            }}
                                            maxLength={16}
                                        />
                                    </Campos>

                                    <InputAntd
                                        label="Nombre:"
                                        requiredICon={true}
                                        style={{ marginBottom: "1%", width: "100%", borderRadius: "15px" }}
                                        styleDiv={{ width: "100%" }}
                                        className="inputblue"
                                        value={Nombre}
                                        setStateValue={setNombre}
                                        placeholder="escribe tu nombre"
                                        valueError={MensajeNombre}
                                        setStateError={setMensajeNombre}
                                        textError={["Este campo es obligatorio", "Solo se permiten letras", ""]}
                                        vacio={false}
                                        expresionRegular={expresiones.textos}
                                        maxLength={50}
                                    />

                                    <InputAntd
                                        label="Apellido paterno:"
                                        requiredICon={true}
                                        style={{ marginBottom: "1%", width: "100%", borderRadius: "15px" }}
                                        styleDiv={{ width: "100%" }}
                                        className="inputblue"
                                        type="text"
                                        value={ApePaterno}
                                        setStateValue={setApePaterno}
                                        placeholder="Escribe tu primer apellido"
                                        valueError={MensajeApePaterno}
                                        setStateError={setMensajeApePaterno}
                                        textError={["Este campo es obligatorio", "Solo se permiten letras", ""]}
                                        vacio={false}
                                        expresionRegular={expresiones.textos}
                                        maxLength={20}
                                    />

                                    <InputAntd
                                        label="Apellido materno:"
                                        style={{ marginBottom: "1%", width: "100%", borderRadius: "15px" }}
                                        styleDiv={{ width: "100%" }}
                                        className="inputblue"
                                        type="text"
                                        value={ApeMaterno}
                                        setStateValue={setApeMaterno}
                                        placeholder="Escribe tu segundo apellido"
                                        valueError={MensajeApeMaterno}
                                        setStateError={setMensajeApeMaterno}
                                        textError={["", "Solo se permiten letras", ""]}
                                        vacio={true}
                                        expresionRegular={expresiones.textos}
                                        maxLength={20}
                                    />

                                    <Row className="widthNormalButton">
                                        <Col className="column">
                                            <InputAntd
                                                label="Teléfono:"
                                                requiredICon={true}
                                                style={{ marginBottom: "1%", borderRadius: "15px" }}
                                                className="inputblue widthRowButton"
                                                value={Telefono}
                                                id="celular"
                                                setStateValue={setTelefono}
                                                placeholder="escribe un teléfono"
                                                valueError={MensajeTelefono}
                                                setStateError={setMensajeTelefono}
                                                textError={["Este campo es obligatorio", "Solo se permiten numeros", "Debe contener 10 digitos"]}
                                                vacio={false}
                                                expresionRegular={expresiones.telefono}
                                                maxLength={10}
                                            />
                                        </Col>

                                        <Col className="column">
                                            <InputAntd
                                                label="Teléfono de emergencia:"
                                                style={{ marginBottom: "1%", borderRadius: "15px" }}
                                                className="inputblue widthRowButtonLocation"
                                                id="celular"
                                                value={TelEmergencia}
                                                setStateValue={setTelEmergencia}
                                                placeholder="escribe un teléfono de emergencia"
                                                valueError={MensajeTelEmergencia}
                                                setStateError={setMensajeTelEmergencia}
                                                textError={["", "Solo se permiten numeros", "Debe contener 10 digitos"]}
                                                vacio={true}
                                                expresionRegular={expresiones.telefono}
                                                maxLength={10}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="widthNormalButton">
                                        <Col className="column">
                                            <ConfigProvider theme={{
                                                token: { borderRadius: 15 }
                                            }}>
                                                <SelectAntd
                                                    label="Género:"
                                                    requiredICon={true}
                                                    vacio={false}
                                                    value={Sexo}
                                                    style={{ marginBottom: "1%" }}
                                                    className="widthRowButton"
                                                    placeholder="Selecciona un género"
                                                    options={[{ value: "Femenino", label: "Femenino" }, { value: "Masculino", label: "Masculino" }]}
                                                    setStateValue={setSexo}
                                                    setStateError={setComboGenero}
                                                    valueError={comboGenero}
                                                    textError={["Debe seleccionar un género"]}
                                                />
                                            </ConfigProvider>
                                        </Col>

                                        <Col className="column">
                                            <InputDate
                                                label="Fecha de nacimiento:"
                                                requiredICon={true}
                                                placeholder="DD/MM/AAAA"
                                                style={{ background: "white", marginBottom: "1%", borderRadius: "15px" }}
                                                className="widthRowButton"
                                                value={!!Nacimiento ? Nacimiento : ""}
                                                setStateValue={setNacimiento}
                                                setStateError={setMensajeNacimiento}
                                                valueError={MensajeNacimiento}
                                                textError={["Debe elegir una fecha de nacimiento", "Debe ser mayor de edad"]}
                                                vacio={false}
                                                mayorEdad={true}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="widthNormalButton">
                                        <Col className="column">
                                            <Campos
                                                label="Estado:"
                                                requiredICon={true}
                                                vacio={false}
                                                valueError={MensajeEstado}
                                                textError={"Debe seleccionar un estado"}
                                            >
                                                <ConfigProvider theme={{
                                                    token: { borderRadius: 15 }
                                                }}>
                                                    <Select
                                                        showSearch
                                                        className="widthRowButton"
                                                        placeholder="Estado"
                                                        optionFilterProp="children"
                                                        filterOption={filterOptions}
                                                        filterSort={filterSort}
                                                        value={Estado}
                                                        onSelect={(e) => {
                                                            setMensajeEstado("true");
                                                            setEstado(e);
                                                            getLocalidades(e);
                                                        }}
                                                        options={EstadosList}
                                                        status={MensajeEstado === "false" && "error"}
                                                    />
                                                </ConfigProvider>
                                            </Campos>
                                        </Col>

                                        <Col className="column">
                                            <Campos
                                                label="Localidad:"
                                                requiredICon={true}
                                                vacio={false}
                                                textError={"Debe seleccionar una localidad"}
                                                valueError={MensajeLocalidad}
                                            >

                                                <ConfigProvider theme={{
                                                    token: { borderRadius: 15 }
                                                }}>
                                                    <Select
                                                        showSearch
                                                        className="widthRowButtonLocation"
                                                        placeholder="Localidad"
                                                        optionFilterProp="children"
                                                        filterOption={filterOptions}
                                                        filterSort={filterSort}
                                                        value={Localidad}
                                                        onSelect={(e) => {
                                                            setMensajeLocalidad("true");
                                                            setLocalidad(e);
                                                        }}
                                                        options={LocalidadesList}
                                                        disabled={!!Estado ? false : true}
                                                        status={MensajeLocalidad === "false" && "error"}
                                                    />
                                                </ConfigProvider>
                                            </Campos>
                                        </Col>
                                    </Row>
                                    <ConfigProvider theme={{
                                        token: { borderRadius: 15 }
                                    }}>
                                        <SelectAntd
                                            id="rol"
                                            label="Rol de usuario:"
                                            requiredICon={true}
                                            vacio={false}
                                            value={UserRoll}
                                            styleDiv={{ width: "100%" }}
                                            style={{ width: "100%" }}
                                            placeholder="Selecciona un rol"
                                            options={[{ value: "1", label: "Médico" }, { value: "4", label: "Asistente" }]}
                                            setStateValue={setUserRoll}
                                            setStateError={setComboRol}
                                            valueError={comboRol}
                                            textError={["Debe seleccionar un rol"]}
                                            extras={[setDesplegar, cleanInputsDoctor]}
                                        />
                                    </ConfigProvider>
                                    {Desplegar === 1 && (
                                        <>
                                            <InputAntd
                                                label="Nombre comercial:"
                                                style={{ marginBottom: "1%", borderRadius: "15px" }}
                                                classNameDiv="widthNormalButton"
                                                className="inputblue widthNormalButton"
                                                type="text"
                                                value={NombreComercial}
                                                setStateValue={setNombreComercial}
                                                placeholder="Escribe tu nombre comercial"
                                                valueError={MensajeNombreComercial}
                                                setStateError={setMensajeNombreComercial}
                                                textError={["", "Solo se permiten letra y números (min. 5 caracteres)", ""]}
                                                vacio={true}
                                                expresionRegular={expresiones.textNumber}
                                                maxLength={100}
                                            />
                                            <InputAntd
                                                label="Dirección comercial:"
                                                style={{ marginBottom: "1%", borderRadius: "15px" }}
                                                classNameDiv="widthNormalButton"
                                                className="inputblue widthNormalButton"
                                                type="text"
                                                value={Direccion}
                                                setStateValue={setDireccion}
                                                placeholder="Escribe tu dirección comercial"
                                                valueError={MensajeDireccion}
                                                setStateError={setMensajeDireccion}
                                                textError={["", "Debe contener un min. de 10 caracteres (numeros, letras y (/,#,-))", ""]}
                                                vacio={true}
                                                expresionRegular={expresiones.direccion}
                                                maxLength={100}
                                            />
                                            <ConfigProvider theme={{
                                                token: { borderRadius: 15 }
                                            }}>
                                                <SelectAntd
                                                    id="sourceChannel"
                                                    label="¿Cómo te enteraste de YGIA?"
                                                    requiredICon={true}
                                                    vacio={false}
                                                    value={CanalOrigen}
                                                    styleDiv={{ width: "100%" }}
                                                    style={{ width: "100%" }}
                                                    placeholder="Selecciona una opción"
                                                    options={
                                                        [
                                                            { value: "0", label: "A través de redes sociales" },
                                                            { value: "1", label: "Visita de un representante YGIA" },
                                                            { value: "2", label: "Buscando en Google" },
                                                            { value: "3", label: "Recomendación de un médico" },
                                                            { value: "4", label: "Influencer: @‌enfermerodigital" },
                                                            { value: "5", label: "MMG" }
                                                        ]
                                                    }
                                                    setStateValue={setCanalOrigen}
                                                    setStateError={setComboCanalOrigen}
                                                    valueError={comboCanalOrigen}
                                                    textError={["Debe seleccionar una opción"]}
                                                    extras={[setDesplegar, cleanInputsDoctor]}
                                                />
                                            </ConfigProvider>
                                        </>
                                    )}
                                    <br />
                                    {Desplegar === 1 &&
                                        <h3 style={{ color: "#148f9f" }}>Datos profesionales</h3>
                                    }
                                    {Desplegar === 1 && (
                                        <Row className="widthNormalButton">
                                            <Col className="column">
                                                <ConfigProvider theme={{
                                                    token: { borderRadius: 15 }
                                                }}>
                                                    <SelectAntd
                                                        label="Prefijo:"
                                                        requiredICon={true}
                                                        vacio={false}
                                                        value={Prefijo}
                                                        // style={{ width: "98%" }}
                                                        className="widthRowButton"
                                                        placeholder="Selecciona un prefijo"
                                                        options={[
                                                            { value: "Dr.", label: "Dr." },
                                                            { value: "Dra.", label: "Dra." },
                                                            { value: "Sr.", label: "Sr." },
                                                            { value: "Sra.", label: "Sra." },
                                                            { value: "Lic.", label: "Lic." },
                                                            { value: "Mtro.", label: "Mtro." },
                                                            { value: "Mtra.", label: "Mtra." },
                                                        ]}
                                                        setStateValue={setPrefijo}
                                                        setStateError={setComboPrefijo}
                                                        valueError={comboPrefijo}
                                                        textError={["Debe seleccionar un prefijo"]}
                                                    />
                                                </ConfigProvider>
                                            </Col>
                                            <Col className="column">
                                                <ConfigProvider theme={{
                                                    token: { borderRadius: 15 }
                                                }}>
                                                    <SelectAntd
                                                        label="Especialidad:"
                                                        requiredICon={true}
                                                        vacio={false}
                                                        value={Profesion}
                                                        // style={{ width: "98%" }}
                                                        className="widthRowButtonLocation"
                                                        placeholder="Selecciona una especialidad"
                                                        options={profesiones}
                                                        setStateValue={setProfesion}
                                                        setStateError={setMensajeProfesion}
                                                        valueError={MensajeProfesion}
                                                        textError={["Debe seleccionar una especialidad"]}
                                                    />
                                                </ConfigProvider>
                                            </Col>
                                        </Row>
                                    )}

                                    {Desplegar === 1 && (
                                        <Row className="widthNormalButton">
                                            <Col className="column">
                                                <InputAntd
                                                    label="Subespecialidad:"
                                                    style={{ marginBottom: "1%", borderRadius: "15px" }}
                                                    className="inputblue widthRowButton"
                                                    type="text"
                                                    value={Subespecialidad}
                                                    setStateValue={setSubespecialidad}
                                                    placeholder="Escribe una subespecialidad"
                                                    valueError={MensajeSubespecialidad}
                                                    setStateError={setMensajeSubespecialidad}
                                                    textError={["", "Solo puede contener letras", ""]}
                                                    vacio={true}
                                                    expresionRegular={expresiones.textos}
                                                    maxLength={40}
                                                />
                                            </Col>
                                            <Col className="column">
                                                <InputAntd
                                                    label="Cédula:"
                                                    style={{ marginBottom: "1%", borderRadius: "15px" }}
                                                    requiredICon={true}
                                                    className="inputblue widthRowButtonLocation"
                                                    type="text"
                                                    id={"cedula"}
                                                    value={Cedula}
                                                    setStateValue={setCedula}
                                                    placeholder="Escribe un número de cédula"
                                                    valueError={MensajeCedula}
                                                    setStateError={setMensajeCedula}
                                                    textError={["Debe escribir una cédula", "Solo puede contener letras y numeros", "Debe contener al menos 4 caracteres"]}
                                                    vacio={false}
                                                    expresionRegular={expresiones.cedula}
                                                    maxLength={20}
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    {Desplegar === 1 && (
                                        <InputAntd
                                            label="Universidad de egreso:"
                                            style={{ marginBottom: "1%", borderRadius: "15px" }}
                                            requiredICon={true}
                                            classNameDiv="widthNormalButton"
                                            className="inputblue widthNormalButton"
                                            type="text"
                                            value={Universidad}
                                            setStateValue={setUniversidad}
                                            placeholder="Escribe una universidad"
                                            valueError={MensajeUniversidad}
                                            setStateError={setMensajeUniversidad}
                                            textError={["Debe escribir una universidad", "", ""]}
                                            vacio={false}
                                            maxLength={50}
                                        />
                                    )}

                                    {Desplegar === 1 && (
                                        <div>
                                            <Campos
                                                label={"Archivo(PDF) o imagen de cédula"}
                                                valueError={archivoExist}
                                                textError={"Debe añadir un archivo"}
                                                styleDiv={{ textAlign: "center" }}
                                                requiredICon={true}
                                                vacio={false}
                                            >
                                                <InputFileSingle archivoValue={CedulaFile} archivo={setCedulaFile} formatos={4} extras={[setOpen, setTypeMessage, setMessage, setArchivoExist]} />
                                            </Campos>
                                        </div>
                                    )}

                                    <ContenedorTerminos>
                                        <div
                                            style={{
                                                alignItems: "center",
                                                display: "flex",
                                                justifyContent: "center",
                                                marginTop: "20px",
                                                marginBottom: "20px"
                                            }}
                                        >
                                            <Checkbox
                                                checked={Terminos}
                                                onChange={(e) => {
                                                    setTerminos(e.target.checked);
                                                    if (e.target.checked) {
                                                        setCheckTerminos("true");
                                                    } else {
                                                        setCheckTerminos("false");
                                                    }
                                                }}
                                            />

                                            <b className="Activar" onClick={openModal2r}> &nbsp; Acepto los términos y condiciones</b>

                                        </div>
                                        <div style={{
                                            alignItems: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}>
                                            <LeyendaError valido={checkTerminos}>Debe aceptar los Términos y Condiciones</LeyendaError>
                                        </div>

                                    </ContenedorTerminos>

                                    <ContenedorBotonCentrado>
                                        {/* <ButtonAntd
                                            onClick={() => {
                                                if (!!UserRoll) {
                                                    onSubmit();
                                                } else {

                                                    if (!!!UserRoll) {
                                                        setComboRol("false");
                                                    }
                                                    if (!!!Sexo) {
                                                        setComboGenero("false");
                                                    }

                                                    if (!!!Nombre) {
                                                        setMensajeNombre("false");
                                                    }

                                                    if (!!!ApePaterno) {
                                                        setMensajeApePaterno("false");
                                                    }

                                                    if (!!!Password) {
                                                        setMensajePassword("false");
                                                    }

                                                    if (!!!Password2) {
                                                        setMensajePassword2("false");
                                                    }

                                                    if (!!!Correo) {
                                                        setMensajeCorreo("false");
                                                    }
                                                    if (!!!Telefono) {
                                                        setMensajeTelefono("false");
                                                    }

                                                    if (!Terminos) {
                                                        setCheckTerminos("false");
                                                    }

                                                    if (!!!Nacimiento) {
                                                        setMensajeNacimiento("false");
                                                    }

                                                    if (!!!Estado) {
                                                        setMensajeEstado("false");
                                                    }

                                                    if (!!!Localidad) {
                                                        setMensajeLocalidad("false");
                                                    }

                                                    setOpen(true);
                                                    setTypeMessage("warning");
                                                    setMessage("Faltan campos por completar");
                                                }
                                            }}
                                        >
                                            Crear cuenta
                                        </ButtonAntd> */}
                                        <Button type='button' className="roundedButtonBlue" onClick={() => {
                                            if (!!UserRoll) {
                                                onSubmit();
                                            } else {

                                                if (!!!UserRoll) {
                                                    setComboRol("false");
                                                }
                                                if (!!!Sexo) {
                                                    setComboGenero("false");
                                                }

                                                if (!!!Nombre) {
                                                    setMensajeNombre("false");
                                                }

                                                if (!!!ApePaterno) {
                                                    setMensajeApePaterno("false");
                                                }

                                                if (!!!Password) {
                                                    setMensajePassword("false");
                                                }

                                                if (!!!Password2) {
                                                    setMensajePassword2("false");
                                                }

                                                if (!!!Correo) {
                                                    setMensajeCorreo("false");
                                                }
                                                if (!!!Telefono) {
                                                    setMensajeTelefono("false");
                                                }

                                                if (!Terminos) {
                                                    setCheckTerminos("false");
                                                }

                                                if (!!!Nacimiento) {
                                                    setMensajeNacimiento("false");
                                                }

                                                if (!!!Estado) {
                                                    setMensajeEstado("false");
                                                }

                                                if (!!!Localidad) {
                                                    setMensajeLocalidad("false");
                                                }

                                                setOpen(true);
                                                setTypeMessage("warning");
                                                setMessage("Faltan campos por completar");
                                            }
                                        }}>
                                            Crear cuenta
                                        </Button>
                                        <h5 style={{ marginTop: "20px" }}>
                                            <span>¿Ya tienes cuenta? </span>
                                            <Link replace={true} to="/login"><span style={{ color: "#148f9f" }}>Iniciar sesión</span></Link>
                                        </h5>
                                    </ContenedorBotonCentrado>
                                </Formulario>
                            </div>
                        </Col>
                        <Col sm={{ flex: "50%" }} className="hideImageRegistro">
                            <Stack style={{ width: "100%", height: "100%" }}>
                                <img src={ImagenMedico} alt="" style={{ width: "100%", height: "100%" }} />
                                <div className="colorBlurRegistro">
                                    <img src={LogoBlanco} alt="" style={{ width: "40%", height: "20%", marginLeft: "5%" }} />
                                </div>
                            </Stack>
                            {/* <div className="imgContainerRegistro">

                                <div className="colorBlurRegistro">

                                </div>
                            </div> */}

                        </Col>

                    </Row>
                )}

                <Modal styleDet={styleDet} isOpen={isopenModal2r} closeModal={closeModal2r}>
                    <div style={{ color: "white", width: "100%", padding: "1% 2%", background: "#148f9f", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <b style={{ cursor: "pointer" }}>Términos y condiciones</b>
                        <b style={{ cursor: "pointer" }} onClick={closeModal2r}>x</b>
                    </div>
                    <div className="ModalTerminos">

                        <div style={{ textAlign: "center", padding: "3%" }}>
                            <img style={{ width: "5rem" }} src={logo} alt="" />
                        </div>
                        <div className="ModalRContainer">
                            <TerminosModal />
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={isopenModalCodigo} styleDet={styleDet}>
                    <div className="ModalCorreoR">
                        <div style={{ textAlign: "center" }}>
                            {loaderModal ? (<LoaderModals />) : (<div>
                                <img
                                    style={{ width: "25%", marginBottom: "3%" }}
                                    src={logo}
                                    alt=""
                                    className="lgo"
                                />
                                <form
                                    action=""
                                    onSubmit={(ev) => {
                                        ev.preventDefault();
                                        validacion();
                                    }}
                                >
                                    <p>El código fue enviado por medio de whatsapp:</p>
                                    <p>
                                        <b>{Telefono}</b>
                                    </p>
                                    <InputAntd
                                        style={{ width: "80%", marginBottom: "1%" }}
                                        className="inputblue"
                                        type="text"
                                        id="codigo"
                                        value={Codigo}
                                        setStateValue={setCodigo}
                                        label="Código:"
                                        placeholder="Escribe tu código"
                                        valueError={MensajeCodigo}
                                        setStateError={setMensajeCodigo}
                                        textError={["Debe escribir un código", "Solo puede contener numeros", "Debe contener 4 digitos"]}
                                        vacio={false}
                                        expresionRegular={expresiones.codigo}
                                        maxLength={4}
                                    />
                                    <br />
                                    <ContenedorBotonCentrado>
                                        <ButtonAntd
                                            style={{ width: "80%" }}
                                            onClick={validacion}
                                        >
                                            Verificar
                                        </ButtonAntd>

                                    </ContenedorBotonCentrado>
                                </form>
                            </div>
                            )}
                        </div>
                    </div>
                </Modal>

                <Snackbar
                    open={open}
                    autoHideDuration={6000}
                    onClose={() => setOpen(false)}
                >
                    <Alert onClose={() => setOpen(false)} severity={typeMessage} sx={{ width: '100%' }}>
                        {message}
                    </Alert>
                </Snackbar>
            </Stack>
        </main>
    );
};

export default RegistroNuevo;
